(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.EventsUpdate",
            {
                url: "/EventsUpdate",
                component: "eventsUpdate",
                PageTitle: "Events + Trip Update",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("eventsUpdate",
    {
        templateUrl: "App/Resources/EventsUpdate/EventsUpdate.template.html",
        controller: eventsUpdateCtrl,
        bindings: {
        }
    });

    eventsUpdateCtrl.$inject = ["amplitudeService"];

    function eventsUpdateCtrl(amplitudeService) {

        var $ctrl = this;
        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        
    }
    
})(window.app, window.angular); // jshint ignore:line